module.exports = "<img *ngIf=\"weather?.weather[0]?.icon\" [src]=\"iconsUrl + weather?.weather[0]?.icon + '.png'\" class=\"img-responsive\">\n\n<ul class=\"text-center\">\n  <li><span>Air Temp:</span> {{ (weather?.main?.temp | number: '1.0-1' | degrees) || 'N/A'}}</li>\n</ul>\n\n<ul class=\"text-center\">\n  <li><span>Wind:</span> {{ weather?.wind?.speed }} m/s</li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/parks/park/weather/park-weather.html
// module id = ./src/app/dashboard/parks/park/weather/park-weather.html
// module chunks = main